export default __webpack_public_path__ + "static/zakupy-header-bg-8f5dea19aa27a30e8056c58d7499abab.png";